// frontend/src/utils/syncClient.js
import axios from "axios";

// Если задали в окружении — берём её, иначе '' (относительный путь)
const BASE = (process.env.REACT_APP_SYNC_URL || "").replace(/\/+$/, "");

function u(path) {
  return (BASE ? BASE : "") + path;
}

export async function syncOzon() {
  await axios.post(u("/sync/ozon"), {});
}

export async function syncYm() {
  await axios.post(u("/sync/ym"), {});
}

export async function syncWb() {
  await axios.post(u("/sync/wb"), {});
}

export async function ozonMarkReady(posting_number) {
  const { data } = await axios.post(u("/ozon/ready"), { posting_number });
  return data;
}

export async function ozonShip(posting_number) {
  const { data } = await axios.post(u("/ozon/ship"), { posting_number });
  return data;
}

export async function ymMarkReady(posting_number) {
  const { data } = await axios.post(u("/ym/ready"), { posting_number });
  return data;
}

export async function ymShip(posting_number) {
  const { data } = await axios.post(u("/ym/ship"), { posting_number });
  return data;
}
